import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import './i18n'
import './index.css'
import App from './App.jsx'
import AuthInitializer from './components/AuthInitializer.jsx'
import { initSentry, SentryErrorBoundary } from './utils/sentry.js'

// Initialize Sentry as early as possible so it catches errors during bootstrap.
initSentry()

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <SentryErrorBoundary
      fallback={({ error }) => (
        <div className="min-h-screen flex items-center justify-center bg-brand-blue text-white p-6">
          <div className="text-center max-w-md">
            <h1 className="font-climate text-4xl mb-4">Ups, coś poszło nie tak</h1>
            <p className="mb-6">
              Wystąpił nieoczekiwany błąd. Odśwież stronę lub wróć na stronę główną.
            </p>
            <p className="text-sm text-white/70 mb-6">
              {error?.message || 'Unknown error'}
            </p>
            <a
              href="/"
              className="inline-block bg-brand-gold text-brand-blue rounded-full px-6 py-2 font-bold hover:bg-brand-gold/90 transition"
            >
              Wróć na stronę główną
            </a>
          </div>
        </div>
      )}
    >
      <BrowserRouter>
        <AuthInitializer>
          <App />
        </AuthInitializer>
      </BrowserRouter>
    </SentryErrorBoundary>
  </StrictMode>,
)
